import { render, staticRenderFns } from "./IconTransport.vue?vue&type=template&id=0f07ac08&scoped=true"
import script from "./IconTransport.vue?vue&type=script&lang=js"
export * from "./IconTransport.vue?vue&type=script&lang=js"
import style0 from "./IconTransport.vue?vue&type=style&index=0&id=0f07ac08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f07ac08",
  null
  
)

export default component.exports